import http from '@/assets/js/http.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/scss/font/font.scss'
import '@/assets/scss/responsive.scss' // 移动端适配（仅 max-width:768px 生效，不影响 PC）
import '@/icons/index.js' // icon
import VueClipboard from 'vue-clipboard2'
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.use(ElementUI)
Vue.use(VueClipboard)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
